import { Component } from '@angular/core';
import { Store } from '@ngxs/store';
import { NkSplashScreenService } from './services/app-services/splash-screen.service';
import { LoadHelperStyleSheet } from './services/app-services/style-injector.service';
import { ThemesService } from './services/app-services/themes.service';
import { firstValueFrom } from 'rxjs';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
  // imports: [RouterModule],
})
export class AppComponent {
  constructor(
    private readonly nkSplashScreenService: NkSplashScreenService,
    private readonly themesService: ThemesService,
    public readonly store: Store
  ) {
    this.initializeApp();
  }

  async initializeApp() {
    LoadHelperStyleSheet();
     await firstValueFrom(this.themesService.init());
     await firstValueFrom(this.nkSplashScreenService.init());
  }
}
